/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Band_AllInputs */

const en_shop_band_all = /** @type {(inputs: Shop_Band_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The whole shop`)
};

const pl_shop_band_all = /** @type {(inputs: Shop_Band_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cały sklep`)
};

/**
* | output |
* | --- |
* | "The whole shop" |
*
* @param {Shop_Band_AllInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_band_all = /** @type {((inputs?: Shop_Band_AllInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Band_AllInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_band_all(inputs)
	return en_shop_band_all(inputs)
});